import { BarChart3, AlertTriangle } from "lucide-react"
import { cn } from "@/lib/utils"
import type { InsightCard } from "./types"

interface ConciergeInsightCardProps {
  card: InsightCard
}

const iconMap = {
  revenue: BarChart3,
  alert: AlertTriangle,
}

const iconBgMap = {
  revenue: "bg-teal-50 text-primary",
  alert: "bg-warning-foreground/10 text-warning",
}

export function ConciergeInsightCard({ card }: ConciergeInsightCardProps) {
  const Icon = iconMap[card.type]

  return (
    <div className="bg-card border border-border rounded-lg p-3.5 mt-2">
      {/* Header */}
      <div className="flex items-center gap-1.5 mb-2">
        <div
          className={cn(
            "h-6 w-6 rounded-md flex items-center justify-center",
            iconBgMap[card.type],
          )}
        >
          <Icon className="h-3.5 w-3.5" />
        </div>
        <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          {card.label}
        </span>
      </div>

      {/* Value */}
      <div className="text-xl font-bold mb-0.5" style={{ color: card.valueColor }}>
        {card.value}
      </div>

      {/* Description */}
      <p className="text-xs text-muted-foreground">{card.description}</p>

      {/* Link */}
      <button
        type="button"
        className="inline-flex items-center gap-1 mt-2 text-xs font-semibold text-primary hover:text-primary/80 transition-colors bg-transparent border-0 cursor-pointer p-0"
      >
        {card.link.text}
      </button>
    </div>
  )
}
